import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import { getFinancialYearLabels } from "../../brsrFinancialYearLabels";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  HEADER_FILL,
  HEADER_ROW,
  TABLE_HEADER_FILL,
  TITLE_ROW,
} from "./principle1DetailHelpers";

const THIN_BLACK = {
  top: { style: "thin", color: { argb: "FF000000" } },
  left: { style: "thin", color: { argb: "FF000000" } },
  bottom: { style: "thin", color: { argb: "FF000000" } },
  right: { style: "thin", color: { argb: "FF000000" } },
};

const BODY_FONT = { name: "Calibri", size: 11 };

const SHEET_TITLE =
  "Percentage of recycled or reused input material to total material (by value) used in production or providing services";

export const SHEET_NAME = "Recycled or reused input";

function borderCell(cell) {
  cell.border = THIN_BLACK;
}

function setCell(ws, row, col, value, options = {}) {
  const cell = ws.getCell(row, col);
  cell.value = value;
  cell.font = options.bold ? { ...BODY_FONT, bold: true } : BODY_FONT;
  borderCell(cell);
  cell.alignment = {
    horizontal: options.align || "center",
    vertical: options.vertical || "middle",
    wrapText: true,
  };
  if (options.fill) cell.fill = options.fill;
}

function formatPercent(value) {
  if (value === null || value === undefined || value === "") return "-";
  const str = String(value);
  return str.includes("%") ? str : `${str}%`;
}

export function buildRecycledOrReusedInputSheet(workbook, sectionC, reportingYear = "") {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });
  const fy = getFinancialYearLabels(reportingYear);
  const fyCurrent = fy.currentYear ? `FY (${fy.currentYear})` : "FY (Current Financial Year)";
  const fyPrevious = fy.previousYear ? `PY (${fy.previousYear})` : "PY (Previous Financial Year)";

  ws.getColumn("A").width = 2;
  ws.getColumn("B").width = 2;
  ws.getColumn("C").width = 2;
  ws.getColumn("D").width = 8;
  ws.getColumn("E").width = 24;
  ws.getColumn("F").width = 16;
  ws.getColumn("G").width = 16;

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_2, { mergeEnd: COL_G });

  ws.mergeCells(TITLE_ROW, COL_D, TITLE_ROW, COL_G);
  setCell(ws, TITLE_ROW, COL_D, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  setCell(ws, HEADER_ROW, COL_D, "Sr. No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_E, "Indicate Input material", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  ws.mergeCells(HEADER_ROW, COL_F, HEADER_ROW, COL_G);
  setCell(
    ws,
    HEADER_ROW,
    COL_F,
    "Recycled or re-used input material to total material",
    { bold: true, fill: TABLE_HEADER_FILL, align: "center" }
  );
  const subHeaderRow = HEADER_ROW + 1;
  setCell(ws, subHeaderRow, COL_D, "", { fill: TABLE_HEADER_FILL });
  setCell(ws, subHeaderRow, COL_E, "", { fill: TABLE_HEADER_FILL });
  setCell(ws, subHeaderRow, COL_F, fyCurrent, { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, subHeaderRow, COL_G, fyPrevious, { bold: true, fill: TABLE_HEADER_FILL, align: "center" });

  const rows = Array.isArray(sectionC?.principle2?.leadershipIndicator?.recycledOrReusedMaterial)
    ? sectionC.principle2.leadershipIndicator.recycledOrReusedMaterial
    : [];
  const dataRows = rows.length ? rows : [{}];
  const dataStartRow = subHeaderRow + 1;

  dataRows.forEach((item, idx) => {
    const row = dataStartRow + idx;
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, item?.indicateInputMaterial || "-", { align: "left" });
    setCell(ws, row, COL_F, formatPercent(item?.currentFinancialYear), { align: "center" });
    setCell(ws, row, COL_G, formatPercent(item?.previousFinancialYear), { align: "center" });
  });

  return ws;
}
